module.exports = __webpack_public_path__ + "img/user-edit.116e3cc4.png";